






































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {},
})
export default class CatchmentDialog extends Vue {
  private address: any = {
    street: '',
    streetNumber: '',
    zip: '',
    city: '',
  };
  private limits: any = [500, 1000, 1500];
  private loading: boolean = false;
  private dialog: any = false;
  private step: any = 1;
  private landType: any = 'städtischen';
  private networkKind: any = 'car';
  private networkUnit: any = 'min';
  private einheit: any = 'min';
  private name: any = '';
  private localAddresses: any = [];
  private selectedAddress: any = null;
  private maxStep: number = 1;
  private error: any = '';
  private states: any =
    ['Alle',
      'Allgemeinmedizin', 'Anästhesiologie und Intensivmedizin', 'Arbeitsmedizin', 'Augenheilkunde und Optometrie',
      'Chirugie', 'Chirurgie', 'Frauenheilkunde und Geburtshilfe', 'Gerichtsmedizin',
      'Hals-, Nasen- und Ohrenkrankheiten', 'Haut- und Geschlechtskrankheiten', 'Hygiene und Mikrobiologie',
      'Immunologie', 'Innere Medizin', 'Kinder- und Jugendheilkunde', 'Kinder- und Jugendpsychiatrie',
      'Lungenkrankheiten', 'Medizinische Genetik', 'Medizinische Physiologie', 'Medizinische Radiologie-Diagnostik',
      'Medizinische und Chemische Labordiagnostik', 'Mund-, Kiefer- und Gesichtschirurgie', 'Neurologie',
      'Neurologie/Psychiatrie', 'Nuklearmedizin', 'Orthopädie und Orthopädische Chirurgie', 'Pathologie',
      'Physikalische Medizin u. Allgemeine Rehabilitation', 'Plastische, Ästhetische u Rekonstruktive Chirurgie',
      'Psychiatrie', 'Psychotherapie', 'Radiologie', 'Strahlentherapie-Radioonkologie',
      'Urologie', 'Zahn-, Mund- und Kieferheilkunde',
    ];

  @Action('doctors/setHauptfach') private setHauptfach!: any;

  @Action('catchments/geocode') private geocode!: any;
  @Action('catchments/getArea') private getArea!: any;
  @Action('catchments/calculateCatchment') private calculateCatchment!: any;

  @Getter('catchments/addresses') private addresses!: any;
  @Getter('doctors/hauptfach') private doctorsHauptfach!: any;

  @Watch('step')
  private stepChanged() {
    if (this.step > this.maxStep) {
      this.maxStep = this.step;
    }
  }

  get unit() {
    if (this.networkUnit === 'min') {
      return 'Minuten';
    }
    return 'Meter';
  }

  get hauptfach() {
    return this.doctorsHauptfach;
  }

  set hauptfach(val) {
    this.setHauptfach(val);
  }

  private async getGeocode() {
    this.loading = true;
    await this.geocode(this.address);

    if (this.addresses) {
      this.localAddresses = this.addresses;
    }
    this.loading = false;
  }

  private async selectAddress(address: any) {
    this.selectedAddress = address;
    this.step = 2;
    const area = await this.getArea({
      x: this.selectedAddress.point.coordinates[0],
      y: this.selectedAddress.point.coordinates[1],
    });

    if (area.data.lage === 1) {
      this.limits = [500, 1000, 2000];
      this.networkKind = 'pedes';
      this.networkUnit = 'meter';
    }
    if (area.data.lage === 2) {
      this.limits = [5, 10, 15];
      this.networkKind = 'car';
      this.networkUnit = 'min';
    }
    if (area.data.lage === 3) {
      this.limits = [5, 10, 15];
      this.networkKind = 'car';
      this.networkUnit = 'min';
    }
  }

  private async startCalculation() {
    this.error = '';
    this.loading = true;
    const success = await this.calculateCatchment({
      x: this.selectedAddress.point.coordinates[0],
      y: this.selectedAddress.point.coordinates[1],
      networkKind: this.networkKind,
      networkUnit: this.networkUnit === 'min' ? 'sec' : 'meter',
      limits: this.networkUnit === 'min' ? this.limits.map((el: any) => (Number(el) * 60)) : this.limits.map((el: any) => Number(el)),
      name: this.name,
      address: this.selectedAddress.name,
    });
    if (!success) {
      this.error = 'Fehlgeschlagen! Bitte prüfen Sie die eingegebenen Daten und achten Sie darauf, dass der Name ' +
        'des Berichts nicht bereits vergeben ist!';
    } else {
      this.dialog = false;

      this.address = {
        street: '',
        streetNumber: '',
        zip: '',
        city: '',
      };
      this.limits = [500, 1000, 1500];
      this.loading = false;
      this.dialog = false;
      this.step = 1;
      this.landType = 'städtischen';
      this.networkKind = 'car';
      this.networkUnit = 'min';
      this.einheit = 'min';
      this.name = '';
      this.localAddresses = [];
      this.selectedAddress = null;
      this.maxStep = 1;
      this.error = '';
    }
    this.loading = false;
  }
}
